import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import StructureLabel from 'components/Luxkit/Label/StructureLabel'
import BodyText from 'components/Luxkit/Typography/BodyText'
import React, { PropsWithChildren } from 'react'

interface Props {
  title?: 'bonus' | 'additional'
}

function AccommodationPackageInclusionsList(props: PropsWithChildren<Props>) {
  const {
    children,
    title,
  } = props

  return <VerticalSpacer gap={8}>
    {title === 'bonus' && <StructureLabel variant="premium">Bonus inclusions:</StructureLabel>}
    {title === 'additional' && <BodyText variant="medium" weight="bold">You also get:</BodyText>}

    <VerticalSpacer gap={4}>
      {children}
    </VerticalSpacer>
  </VerticalSpacer>
}

export default AccommodationPackageInclusionsList
